import React from "react";

import { ConfirmOptions } from "src/features/confirm/types";

export const ConfirmContext = React.createContext<
	(options: ConfirmOptions) => Promise<unknown>
>(() => Promise.resolve());
